import { fromFetch } from 'rxjs/fetch';

import { requiredHeaders } from '../../../models/required-headers';
import { selectData } from '../../../utils/select-data';
import { withJwt } from '../../../utils/with-jwt';
import { fleetEnvironment } from '../fleet-environment';
import { avoidFavorSetSchema } from '../schemas/avoid-favor-set.schema';

/**
 * Requests a specific Avoid Favor Set
 * @param setId The set ID of the Avoid Favor Set being requested
 * @returns The Avoid Favor Set
 */
export function getAvoidFavorSetsId(this: unknown, setId: number) {
  const requestUrl = `${
    fleetEnvironment.resolve(this).avoidFavorSetsUrl
  }/${setId}`;
  return withJwt((jwtAuthHeaders) =>
    fromFetch(
      new Request(requestUrl, {
        method: 'GET',
        headers: {
          ...requiredHeaders,
          ...jwtAuthHeaders,
        },
      })
    )
  ).pipe(selectData(avoidFavorSetSchema));
}
